// Factory functions for creating empty objects
export const createEmptyBoard = (createdBy) => ({
    id: '',
    title: 'New Board',
    description: '',
    isStarred: false,
    createdAt: new Date(),
    updatedAt: new Date(),
    createdBy,
    members: [createdBy],
    groups: [],
    activities: [],
    labels: getDefaultLabels(),
    columnOrder: ['assignee-picker', 'agent-picker', 'status-picker', 'priority-picker'],
    availableColumns: [
        'assignee-picker',
        'agent-picker',
        'status-picker',
        'priority-picker',
        'date-picker',
        'number-picker',
        'file-picker',
        'progress-picker',
        'updated-picker',
        'checkbox-picker',
        'text-picker'
    ],
    viewType: 'table'
});
export const createEmptyGroup = () => ({
    id: '',
    title: 'New Group',
    color: '#579bfc',
    position: 0,
    tasks: [],
    isCollapsed: false
});
export const createEmptyTask = () => ({
    id: '',
    title: 'New Task',
    status: 'Not Started',
    priority: 'Medium',
    assigneeIds: [],
    agentIds: [],
    updatedBy: {
        date: Date.now(),
        userId: '',
        userAvatar: ''
    },
    comments: [],
    customFields: {},
    automationConfig: {
        autoAssignAgent: false,
        agentTriggers: [],
        escalationRules: [],
        autonomousMode: false
    }
});
export const createEmptyComment = (authorId, authorName) => ({
    id: '',
    content: '',
    authorId,
    authorName,
    authorAvatar: '',
    createdAt: Date.now(),
    style: {
        fontWeight: 'normal',
        fontStyle: 'normal',
        textDecoration: 'none',
        textAlign: 'left'
    }
});
export const getDefaultLabels = () => [
    { id: 'status-done', title: 'Done', color: '#00c875', type: 'status' },
    { id: 'status-working', title: 'Working on it', color: '#fdab3d', type: 'status' },
    { id: 'status-stuck', title: 'Stuck', color: '#e2445c', type: 'status' },
    { id: 'status-not-started', title: 'Not Started', color: '#c4c4c4', type: 'status' },
    { id: 'priority-high', title: 'High', color: '#e2445c', type: 'priority' },
    { id: 'priority-medium', title: 'Medium', color: '#fdab3d', type: 'priority' },
    { id: 'priority-low', title: 'Low', color: '#00c875', type: 'priority' },
    { id: 'priority-critical', title: 'Critical', color: '#bb3354', type: 'priority' }
];
export const getDefaultBoardFilter = () => ({
    title: '',
    assigneeId: '',
    status: [],
    priority: []
});
